module.exports = __webpack_public_path__ + "img/P2-B2.6941377d.svg";